import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Apply from "./pages/Apply";
import NotFound from "./pages/NotFound";
import Maintenance from "./pages/Maintenance";
import MyVault from "./pages/MyVault";
import Resources from "./pages/Resources";
import Supervisor from "./pages/Supervisor";
import Analytics from "./pages/Analytics";
import SupervisorIncidentHistory from "./pages/SupervisorIncidentHistory";

import Settings from "./pages/Settings";
import Training from "./pages/Training";
import Profile from "./pages/Profile";
// Support page removed
import AdminPanel from "./pages/AdminPanel";
import Onboarding from "./pages/Onboarding";
import ProtectedRoute from "./components/ProtectedRoute";
import MobileRoute from "./components/MobileRoute";
import MaintenanceRoute from "./components/MaintenanceRoute";
import { AuthProvider } from "./context/AuthContext";
import { AnnouncementProvider } from "./context/AnnouncementContext";
import { MobileProvider } from "./context/MobileContext";
import { MaintenanceProvider } from "./context/MaintenanceContext";
import DashboardWrapper from "./pages/DashboardWrapper";
import MobileDashboard from "./pages/MobileDashboard";
import AnnouncementModal from "./components/AnnouncementModal";
import UserModalAlert from "./components/UserModalAlert";

function App() {
  return (
    <AuthProvider>
      <AnnouncementProvider>
        <MaintenanceProvider>
          <MobileProvider>
            <Router>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/apply" element={<Apply />} />
                <Route path="/maintenance" element={<Maintenance />} />
                <Route
                  path="/onboarding"
                  element=
                    {
                      <ProtectedRoute>
                        <Onboarding />
                      </ProtectedRoute>
                    }
                />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <MobileRoute 
                      desktopComponent={<DashboardWrapper />} 
                      mobileComponent={<MobileDashboard />} 
                    />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/my-vault"
                element={
                  <MaintenanceRoute>
                    <MobileRoute 
                      desktopComponent={
                        <ProtectedRoute>
                          <MyVault />
                        </ProtectedRoute>
                      }
                      redirectMobile
                    />
                  </MaintenanceRoute>
                }
              />

              <Route
                path="/supervisor"
                element={
                  <MaintenanceRoute>
                    <MobileRoute 
                      desktopComponent={
                        <ProtectedRoute requiredRoles={["admin", "supervisor"]}>
                          <Supervisor />
                        </ProtectedRoute>
                      }
                      redirectMobile
                    />
                  </MaintenanceRoute>
                }
              />

              <Route
                path="/supervisor/history"
                element={
                  <MaintenanceRoute>
                    <MobileRoute 
                      desktopComponent={
                        <ProtectedRoute requiredRoles={["admin", "supervisor"]}>
                          <SupervisorIncidentHistory />
                        </ProtectedRoute>
                      }
                      redirectMobile
                    />
                  </MaintenanceRoute>
                }
              />

              <Route
                path="/supervisor/analytics"
                element={
                  <MaintenanceRoute>
                    <MobileRoute 
                      desktopComponent={
                        <ProtectedRoute requiredRoles={["admin", "supervisor"]}>
                          <Analytics />
                        </ProtectedRoute>
                      }
                      redirectMobile
                    />
                  </MaintenanceRoute>
                }
              />



              <Route
                path="/my-vault/resources"
                element={
                  <MaintenanceRoute>
                    <ProtectedRoute>
                      <Resources />
                    </ProtectedRoute>
                  </MaintenanceRoute>
                }
              />

              <Route
                path="/my-vault/training"
                element={
                  <MaintenanceRoute>
                    <MobileRoute 
                      desktopComponent={
                        <ProtectedRoute>
                          <Training />
                        </ProtectedRoute>
                      }
                      redirectMobile
                    />
                  </MaintenanceRoute>
                }
              />

              <Route
                path="/my-vault/profile"
                element={
                  <MaintenanceRoute>
                    <MobileRoute 
                      desktopComponent={
                        <ProtectedRoute>
                          <Profile />
                        </ProtectedRoute>
                      }
                      redirectMobile
                    />
                  </MaintenanceRoute>
                }
              />

              {/* Support page removed */}

              <Route
                path="/admin-panel"
                element={
                  <MobileRoute 
                    desktopComponent={
                      <ProtectedRoute requiredRoles={["admin"]}>
                        <AdminPanel />
                      </ProtectedRoute>
                    }
                    redirectMobile
                  />
                }
              />

              <Route
                path="/settings"
                element={
                  <MaintenanceRoute>
                    <MobileRoute 
                      desktopComponent={
                        <ProtectedRoute>
                          <Settings />
                        </ProtectedRoute>
                      }
                      redirectMobile
                    />
                  </MaintenanceRoute>
                }
              />

              <Route path="/analytics" element={<Navigate to="/supervisor/analytics" replace />} />
              <Route path="/training" element={<Navigate to="/my-vault/training" replace />} />
              <Route path="/profile" element={<Navigate to="/my-vault/profile" replace />} />

              {/* default redirect */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              
              {/* 404 - catch all unknown routes */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <AnnouncementModal />
            <UserModalAlert />
          </Router>
        </MobileProvider>
      </MaintenanceProvider>
      </AnnouncementProvider>
    </AuthProvider>
  );
}

export default App;